import { createEvent } from 'effector';

import { AllMenuItemNames } from '@m/constants/CustomerAppSideMenuItemNames';

export const showSideMenu = createEvent();

export const hideSideMenu = createEvent();

export const setSideMenuActiveItem = createEvent<{ itemName: AllMenuItemNames }>();

export const toggleSideMenu = createEvent();

export const showLastVisitModal = createEvent();

export const hideLastVisitModal = createEvent();

export const showConfirmationModal = createEvent();

export const hideConfirmationModal = createEvent();

export const showHelpModal = createEvent();

export const hideHelpModal = createEvent();

export const showAppModal = createEvent<{
  content: React.ReactElement;
  styleOverrides?: string;
  timeout?: number;
}>();

export const hideAppModal = createEvent<void>();

export const setIsValetPaymentScreenOpen = createEvent<boolean>();

export const setIsValetCancelRequestScreenOpen = createEvent<boolean>();

export const setHideActiveVisitValidationScanner = createEvent<boolean>();

// TODO: remove this when we have a better solution for the parking pass receipt
export const setShowParkingPassReceiptSheet = createEvent<boolean>();
